module.exports = __webpack_public_path__ + "img/GoLand_icon.18a4fa6b.png";